import { render, staticRenderFns } from "./SetLocation.vue?vue&type=template&id=53fe77e5"
import script from "./SetLocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetLocation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SetLocation.vue?vue&type=style&index=0&id=53fe77e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports